import React from "react";
import { Homestyle } from "./Style";
import Typography from "@mui/material/Typography";
import { List, ListItem, Box, Divider } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { userService } from '../../services/user.services';
import { userConstants } from '../../constants/user.constants';
import { logoutChannel } from '../../helpers/logoutChannel';

// `children` is the avatar+name/email cluster (see Topbar/index.js) — the whole cluster
// is the click target that opens this menu now, rather than a separate chevron icon.
// `displayName`/`email` are shown inside the menu itself below 1370px, where
// Topbar/index.js hides its own inline name/email block for lack of room.
export default function Dropdownnav({ children, displayName, email }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleGotoProfile=()=>{
    navigate("/myProfile")
  }

  const handleLogout = async () => {
    await userService.logout();
    dispatch({ type: userConstants.LOGOUT });
    sessionStorage.clear();
    logoutChannel.postMessage('logout');
    navigate('/');
  };
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleMenu(event);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Homestyle>
      {/* <Menu> portals its Paper/Backdrop to document.body, but React still bubbles
          their events up through the *React* tree, not the DOM tree — nesting it inside
          the clickable trigger div meant a backdrop click closed the menu and then
          immediately reopened it (bubbling into this div's onClick). Keeping Menu as a
          sibling instead of a child avoids that. */}
      <div
        onClick={handleMenu}
        onKeyDown={handleMenuKeyDown}
        role="button"
        tabIndex={0}
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
      >
        {children}
      </div>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            width: "220px",
            "@media (min-width:1370px)": { width: "160px" },
            marginTop: "8px",
            borderRadius: "10px",
            border: "1px solid #e4e7ec",
            boxShadow: "0px 12px 24px -4px rgba(16,24,40,0.10), 0px 4px 6px -2px rgba(16,24,40,0.05)",
            overflow: "hidden",
          },
          "& .MuiMenu-list": {
            padding: "4px",
          },
        }}
      >
        <Box sx={{ display: "block", "@media (min-width:1370px)": { display: "none" }, padding: "8px 12px 6px" }}>
          <Typography
            component="div"
            sx={{ fontFamily: "Outfit", fontWeight: 600, fontSize: "14px", color: "#111827", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", lineHeight: 1.3 }}
          >
            {displayName}
          </Typography>
          {email && (
            <Typography
              component="div"
              sx={{ fontFamily: "Outfit", fontWeight: 400, fontSize: "12px", color: "#9ca3af", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", lineHeight: 1.3 }}
            >
              {email}
            </Typography>
          )}
        </Box>
        <Divider sx={{ display: "block", "@media (min-width:1370px)": { display: "none" }, margin: "2px 0 4px" }} />
        <MenuItem
          onClick={()=>handleLogout()}
          sx={{
            minHeight: "auto",
            padding: "6px 10px",
            borderRadius: "8px",
            transition: "background-color 150ms ease",
            "&:hover": {
              backgroundColor: "#fff5f5",
            },
          }}
        >
          <List
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              padding: 0,
              "& .MuiListItem-root": {
                padding: "unset",
              },
            }}
          >
            <ListItem >
              <svg
                width="18"
                height="18"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5M13.3333 14.1667L17.5 10M17.5 10L13.3333 5.83333M17.5 10H7.5"
                  stroke="#D32028"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </ListItem>
            <ListItem>
              <Typography
                variant="body1"
                component="div"
                fontFamily="Inter-Medium"
                color="warning.main"
                sx={{ lineHeight: 1.3, fontSize: "14px", fontWeight: 600 }}
              >
                Logout
              </Typography>
            </ListItem>
          </List>
        </MenuItem>
      </Menu>
    </Homestyle>
  );
}
